import { Component, Inject, OnInit } from '@angular/core';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-cargo-uncared',
  templateUrl: './modal-cargo-uncared.component.html',
  styleUrls: ['./modal-cargo-uncared.component.scss']
})
export class ModalCargoUncaredComponent implements OnInit {
  public type: string;
  public title: string;
  public text: string;
  public cargos: Cargo[];
  public filters: string = '';
  public total: number = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      type: string,
      title: string,
      text: string,
      cargos: Cargo[],
      filters?: string,
      total?: number
    },
    public dialogRef: MatDialogRef<ModalCargoUncaredComponent>
  ) { }

  ngOnInit() {
    if (this.data) {
      this.type = this.data.type || this.type;
      this.cargos = this.data.cargos || [];
      this.title = this.data.title || this.title;
      this.text = this.data.text || this.text;
      this.filters = this.data.filters || '';
      this.total = this.data.total || 0;
    }
  }
  public close(): void {
    this.dialogRef.close();
  }

}
